import { color, spacer } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';

export const rowMarker = stylex.defineMarker();

export const styles = stylex.create({
  row: {
    position: 'relative',
    isolation: 'isolate',
    width: '100%',
    cursor: 'default',
  },
  dragHighlight: {
    position: 'absolute',
    left: `calc(-1 * ${spacer.spacer16px})`,
    right: `calc(-1 * ${spacer.spacer16px})`,
    top: 0,
    bottom: 0,
    backgroundColor: color.bgHover,
    zIndex: -1,
    pointerEvents: 'none',
  },
  dropIndicator: {
    position: 'absolute',
    left: `calc(-1 * ${spacer.spacer16px})`,
    right: `calc(-1 * ${spacer.spacer16px})`,
    height: 1,
    backgroundColor: color.borderSelected,
    zIndex: 1,
    pointerEvents: 'none',
  },
  dropTop: {
    top: `calc(-1 * ${spacer.spacer4px})`,
  },
  dropBottom: {
    bottom: `calc(-1 * ${spacer.spacer4px})`,
  },
  dragHandle: {
    position: 'absolute',
    left: `calc(-1 * ${spacer.spacer16px})`,
    top: 0,
    width: spacer.spacer16px,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '--fpl-icon-color': color.icon,
  },
  dragHandleEnabled: {
    opacity: {
      default: 0,
      [stylex.when.ancestor(':hover', rowMarker)]: 1,
    },
    cursor: {
      default: 'grab',
      ':active': 'grabbing',
    },
  },
  dragHandleDisabled: {
    opacity: 0,
    cursor: 'default',
  },
  fields: {
    minWidth: 0,
  },
  percentSuffix: {
    display: 'flex',
    justifyContent: 'center',
    width: 22,
  },
});
